module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-SemiBoldItalic.021c007.woff2";